import axiosClient from "../axiosClient";

const route = "api/bank";
const analyzeRoute = "/bankAnalizedInvoice";

export const analyzeInvoiceForBank = async (filesData) => {
  try {
    const response = await axiosClient.post(
      `${route}/extractCertificateInfo`,
      filesData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAnalyzedInvoice = async (invoiceId) => {
  try {
    const response = await axiosClient.get(
      `/multiContainerInvoiceWithoutC/analyzedInvoice/${invoiceId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createAnalyzedApplication = async (data) => {
  try {
    const response = await axiosClient.post(
      `/multiContainerInvoiceWithoutC/analyzedInvoice`,
      { applicationData: data.applicationData, invoiceId: data.invoiceId, status: data.status, rejectionReason: data.rejectionReason, }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAnalyzedApplications = async (filterParams) => {
  try {
    const response = await axiosClient.get(analyzeRoute, {
      params: filterParams,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAnalyzedApplicationById = async (applicationId) => {
  try {
    const response = await axiosClient.get(`${analyzeRoute}/${applicationId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateAnalyzedApplication = async (
  applicationId,
  applicationData
) => {
  try {
    const response = await axiosClient.put(
      `${analyzeRoute}/${applicationId}`,
      applicationData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteAnalyzedApplication = async (applicationId) => {
  try {
    const response = await axiosClient.delete(
      `${analyzeRoute}/${applicationId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const reportAnalysisBug = async (formData) => {
  try {
    const userId = localStorage.getItem("userId");
    const organizationId = localStorage.getItem("organizationId");

    if (userId && !formData.has("userId")) {
      formData.append("userId", userId);
    }
    if (organizationId && !formData.has("organizationId")) {
      formData.append("organizationId", organizationId);
    }

    const response = await axiosClient.post(
      `/api/bugs/report`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBugReports = async (params) => {
  try {
    const response = await axiosClient.get(`/api/bugs`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("SuperAdminToken")}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBugReportById = async (id) => {
  try {
    const response = await axiosClient.get(`/api/bugs/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("SuperAdminToken")}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateBugReportStatus = async (id, status) => {
  try {
    const response = await axiosClient.patch(
      `/api/bugs/${id}/status`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("SuperAdminToken")}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
